export default {
    install(app) {
      app.config.globalProperties.$fileDate = function() {
        let date = new Date(); 
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let year = date.getFullYear();
        return `${day}_${month}_${year}`;
      },
      // insert priviledge check
      app.config.globalProperties.$insertAccess = function(route) {
        if (route === '/sales/add-sale-invoice') {
          return true;
        } else {
          let flag = false;
          var menusNotParsed = localStorage.getItem("menu");
          if (menusNotParsed) {
            var menus = JSON.parse(menusNotParsed);
            var menu = {};
            var menuChild = {};
            for (menu of menus) {
              if (!flag) {
                for (menuChild of menu.sub_module) {
                  var child = {};
                  if (!flag) {
                    for(child of menuChild.menu){
                      let menuLink = child.link;
                      if (menuLink === route && child.insert == 1) {
                        flag = true;
                        break;
                      }
                    }
                  }
                  else{
                    break;
                  }
                }
              } else {
                break;
              }
            }
          }
          return flag;
        }
      };
      // update priviledge check
      app.config.globalProperties.$updateAccess = function(route) {
        let flag = false;
        var menusNotParsed = localStorage.getItem("menu");
        if (menusNotParsed) {
          var menus = JSON.parse(menusNotParsed);
          var menu = {};
          var menuChild = {};
          for (menu of menus) {
            if (!flag) {
              for (menuChild of menu.sub_module) {
                var child = {};
                if (!flag) {
                  for(child of menuChild.menu){
                    let menuLink = child.link;
                    if (menuLink === route && child.update == 1) {
                      flag = true;
                      break;
                    }
                  }
                }
                else{
                  break;
                }
              }
            } else {
              break;
            }
          }
        }
        return flag;

      };
      // delete priviledge check
      app.config.globalProperties.$deleteAccess = function(route) {
        let flag = false;
        var menusNotParsed = localStorage.getItem("menu");
        if (menusNotParsed) {
          var menus = JSON.parse(menusNotParsed);
          var menu = {};
          var menuChild = {};
          for (menu of menus) {
            if (!flag) {
              for (menuChild of menu.sub_module) {
                var child = {};
                if (!flag) {
                  for(child of menuChild.menu){
                    let menuLink = child.link;
                    if (menuLink === route && child.delete == 1) {
                      flag = true;
                      break;
                    }
                  }
                }
                else{
                  break;
                }
              }
            } else {
              break;
            }
          }
        }
        return flag;

      };
      // view priviledge check
      app.config.globalProperties.$viewAccess = function(route) {
        let flag = false;
        var menusNotParsed = localStorage.getItem("menu");
        if (menusNotParsed) {
          var menus = JSON.parse(menusNotParsed);
          var menu = {};
          var menuChild = {};
          for (menu of menus) {
            if (!flag) {
              for (menuChild of menu.sub_module) {
                var child = {};
                if (!flag) {
                  for(child of menuChild.menu){
                    let menuLink = child.link;
                    if (menuLink === route && child.view == 1) {
                      flag = true;
                      break;
                    }
                  }
                }
                else{
                  break;
                }
              }
            } else {
              break;
            }
          }
        }
        return flag;
      };








      app.config.globalProperties.$numberFormat = function(number) {
        
          // Format the number with commas and two decimal places
          if (number === null || number === undefined || isNaN(number)) {
            return 0.00
          }
          return number.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }); // Output: "1,234,567.89"

      };
    },
  };
  